import { MenteeStatusValues } from 'enums/MenteeStatus';
import { MentorshipStatusValues } from 'enums/MentorshipStatus';

export const menteeTags: (MenteeStatusValues | MentorshipStatusValues)[] = [
  'FILLING_FORM',
  //'REFUSED_MENTORSHIP', 
  'SIGNING_CHART',
  'ELIGIBLE',
  //'REFUSED',
  //'MENTOR_ACCEPTING',
  //'WAITING_MENTOR',
  //'WAITING_MENTEE',
  //'REFUSED_MENTOR',
  //'REFUSED_MENTEE',
  //'FIRST_INTERVIEW',
  //'LATE_MENTEE_FIRST_INTERVIEW',
  //'LATE_MENTOR_FIRST_INTERVIEW',
  'ONGOING',
  //'LATE_MENTOR',
  //'LATE_MENTEE',
  'INTERRUPTION_REQUEST_MENTEE',
  'INTERRUPTION_REQUEST_MENTOR',
  'INTERRUPTED_ADMIN',
  'FINISHED_ADMIN',
  'FINISHED_DATE',
];

export const menteeAssociateTags: (
  | MenteeStatusValues
  | MentorshipStatusValues
)[] = [
    'ELIGIBLE',
    'REFUSED_MENTEE',
    'REFUSED_MENTOR',
    'INTERRUPTED_ADMIN',
    'FINISHED_ADMIN',
    'FINISHED_DATE',
  ];

export const getIsMenteeStatus = (
  status: string,
): status is MenteeStatusValues => {
  return [
    'FILLING_FORM',
    'REFUSED_MENTORSHIP',
    'SIGNING_CHART',
    'ELIGIBLE',
    'REFUSED',
    'MENTORSHIP_ACTIVE',
  ].includes(status);
};
